import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 17 16.946"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs></defs><g id=\"Group_2729\" transform=\"translate(2194 -64.525)\"><g id=\"Group_2732\" transform=\"translate(0 1)\"><g id=\"Group_2731\" transform=\"translate(-2193.641 63.525)\"><rect id=\"Rectangle_2197\" width=\"3.014\" height=\"4.217\" class=\"cls-1\" rx=\"1\" transform=\"translate(0 9.683)\"></rect><rect id=\"Rectangle_2198\" width=\"3.02\" height=\"8.434\" class=\"cls-1\" rx=\"1\" transform=\"translate(4.368 5.466)\"></rect><rect id=\"Rectangle_2199\" width=\"3.02\" height=\"11.825\" class=\"cls-1\" rx=\"1\" transform=\"translate(8.742 2.075)\"></rect><rect id=\"Rectangle_2200\" width=\"3.014\" height=\"13.9\" class=\"cls-1\" rx=\"1\" transform=\"translate(12.882)\"></rect></g><rect id=\"Rectangle_2201\" width=\"17\" height=\"2\" class=\"cls-1\" rx=\".5\" transform=\"translate(-2194 78.471)\"></rect></g></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };